'use client';

import { useEffect, useState } from 'react';
import {
  isCrossWindowSyncReady,
  subscribeCrossWindowSyncReady,
} from '../store/crossWindowSync';

export function useCrossWindowSyncReady(): boolean {
  const [isReady, setIsReady] = useState(isCrossWindowSyncReady);

  useEffect(() => {
    if (isReady) {
      return;
    }

    if (isCrossWindowSyncReady()) {
      setIsReady(true);

      return;
    }

    return subscribeCrossWindowSyncReady(() => {
      setIsReady(true);
    });
  }, [isReady]);

  return isReady;
}
